/**
 * This method filter out all ready to dispatch order that can be in pickup tab.
 * If it moves to ready to dispatch bu cubby manager, then it should be in completed tab
 * otherwise in pickup tab
 * @param isAssignerMode
 * @param readyToDispatchOrders
 */
export function getApplicablePickupAreaOrdersFromReadyToDispatch(isAssignerMode, readyToDispatchOrders) {
    if (!isAssignerMode) {
        return readyToDispatchOrders;
    }
    return readyToDispatchOrders.filter(order => !isReadyToDispatchedOrderFromCubby(order));
}


/**
 * This method filter out all order that can be in completed tab at assigner mode.
 * @param orders
 */
export function getApplicableCompletedOrdersWithAssignerMode(orders) {
    return orders.filter(order => isReadyToDispatchedOrderFromCubby(order));
}

/**
 * This method filter out all order that can be show in dashboard.
 * @param orders
 */
export function getDispatchedActiveOrdersForDashboard(orders) {
    return orders.filter(order => !isOrderDispatchedCheckedAsCompleted(order));
}

/**
 * This method give true when order is dispatched.
 * And if it has any driver event, then it must include both Checked in and checked out.
 * @param order
 * @returns {boolean}
 */
export function isOrderDispatchedCheckedAsCompleted(order) {
    const status = order.statusHistory.map(item => item.status);
    status.push(order.status);
    if (status.includes('DISPATCHED')) {
        if (status.includes('DRIVER_CHECKED_IN')) {
            return status.includes('DRIVER_CHECKED_OUT');
        }
        return true;
    }
    return false
}

function isReadyToDispatchedOrderFromCubby(order) {
    const cubbyReadyToDispatchedOrder = order.statusHistory.filter((item) => {
        return item.status === 'READY_TO_DISPATCH' && item.metadata?.SOURCE === 'CUBBY-MANAGER'
    });
    return cubbyReadyToDispatchedOrder.length > 0;
}

export function isOrderReady(order) {
    const alreadyReadyToDispatched = order.statusHistory.filter((item) => {
        return item.status === 'READY_TO_DISPATCH' || item.status === 'DISPATCHED'
    });
    return alreadyReadyToDispatched.length > 0;
}